<template>
  <v-card>
    <v-card-title primary-title>
      <v-icon class="mr-4">mdi-clipboard-arrow-down</v-icon>
      Bekräfta utlämning
    </v-card-title>

    <v-card-subtitle>UUID: {{ $route.params.uuid }}</v-card-subtitle>

    <v-card-text>
      Är du säker på att du vill utlämmna förfrågan?
    </v-card-text>

    <v-divider></v-divider>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn text @click="onClose">
        Avbryt
      </v-btn>
      <v-btn type="submit" color="success" text @click="onConfirm">
        Utlämmna
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'InquiriesResolveConfirm',

  methods: {
    onConfirm() {
      this.$emit('confirm')
    },

    onClose() {
      this.$emit('close')
    },
  },
}
</script>
